import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        width: '100%',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const NSDLIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 226.8 226.8"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorSelected}
                                d="M199.4,121.6l-3.9,0.1c-0.4,5.5-1.8,8.7-4.1,9.7c-2.3,1-5.5,1.5-9.7,1.5c-1.4,0.1-2.8-0.2-4.1-0.7
		c-1.1-0.5-1.7-2-1.7-4.4v-26.4c0-3.1,0.3-5.1,1-6s2.3-1.3,5-1.4v-5h-23.1v5c2.7,0,4.4,0.4,5,1.3s1,2.9,1,5.9v24.6c0,3-0.3,5-1,5.9
		s-2.4,1.3-5,1.3v4.9h39.8L199.4,121.6L199.4,121.6z"
                            />
                            <path
                                className={colorSelected}
                                d="M159.2,114.5v-1.4c0-8.4-2.5-14.6-7.6-18.4c-5-3.8-11-5.8-17.2-5.8h-22.9v5c2.7,0,4.4,0.4,5,1.3
		c0.7,0.9,1,2.9,1,5.9v24.6c0,3-0.3,5-1,5.9c-0.7,0.9-2.4,1.3-5,1.3v4.9l23.8-0.1h1c3.5-0.1,6.9-0.7,10.1-1.8
		c3.5-1.3,6.4-3.7,8.4-6.8c1.3-1.9,2.3-4,3-6.2c0.7-2.3,1.2-4.6,1.4-7C159.1,115.5,159.2,115,159.2,114.5z M144.7,126.9
		c-2,4.1-5.5,6.1-10.6,6.1c-1.8,0-3.3-0.3-4.1-1c-0.9-0.7-1.3-2.3-1.3-4.8l0.1-33.4l3.6,0.1c1.2,0,2.4,0.1,3.6,0.1
		c3.4,0.1,6.5,2.1,8.1,5.1c1.8,3.2,3,6.7,3.5,10.3c0.1,0.6,0.1,1.2,0.1,1.8c0.1,0.6,0.1,1.2,0.1,1.8
		C147.8,117.7,146.8,122.5,144.7,126.9z"
                            />
                            <path
                                className={colorSelected}
                                d="M98.8,106.4l-6.7-3.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-1-0.6-1.8-1.3-2.6-2.1
		c-0.8-0.9-1.3-2.1-1.2-3.3c-0.1-1.3,0.4-2.7,1.4-3.6c0.9-0.7,2-1.3,3.2-1.5c0.2,0,0.5-0.1,0.7-0.1h0.7c2.7,0,5.2,1,7.1,2.9
		c2.1,1.9,3.6,4.5,3.9,7.4h3.8V88l0,0l-3.8,0.1l-0.7,2.9c-1.6-1-3.3-1.8-5.1-2.4c-1.8-0.7-3.6-1-5.5-1c-3.6-0.1-7.1,1.3-9.8,3.6
		c-2.9,2.4-4.3,6-4.3,10.8c0,4.4,1.3,7.7,3.6,9.8c2.4,2.1,5.2,4,8.1,5.5c0.1,0.1,0.1,0.1,0.3,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		c0.6,0.3,1.3,0.7,2.1,1s1.6,0.7,2.4,1.2c1.6,0.9,3,1.9,4.4,3.2c1.3,1.2,2.1,2.8,2,4.6c0.1,2-0.7,3.8-2.1,5.2
		c-1.3,1.2-3,1.8-4.8,1.8c-3.2,0-6.3-1.3-8.5-3.6c-2.5-2.4-4.3-5.5-5.2-8.9h-3.9v16.2h3.9l0.6-3.7c1.6,1.2,3.4,2.1,5.3,2.9
		c1.8,0.7,3.8,1.3,5.7,1.6c0.4,0,0.8,0.1,1.3,0.1h1.3c4.1,0.1,8.1-1.5,11-4.4c2.9-3,4.4-7.1,4.4-12.4c0-4.5-1.3-7.9-3.6-10.1
		C104.6,109.9,101.8,107.9,98.8,106.4z"
                            />
                            <path
                                className={colorSelected}
                                d="M58.9,93.9h0.9c2.1,0.1,3.6,0.5,4.4,1.3c0.8,0.7,1.2,2.4,1.2,5l0.2,24.2c-0.1-0.7-0.2-1.2-0.4-1.7
		c-0.2-0.5-0.4-1-0.6-1.5c-0.1-0.2-0.3-0.5-0.4-0.7c-0.2-0.2-0.4-0.6-0.5-0.9L45.3,88.9l0,0l-17.8,0.1v5c2.7,0,4.3,0.4,5,1.3
		c0.7,0.9,1,2.9,1,5.9V127c0,2.4-0.4,3.8-1.1,4.4c-0.8,0.5-1.8,0.9-2.8,1c-0.4,0-0.7,0-1,0.1c-0.4,0.1-0.7,0.1-1.1,0.1v5.2h17.8
		v-5.1c-1.6,0-3.3-0.3-4.7-1c-1.2-0.6-1.8-2.3-1.8-5L38.4,98c0.1,0.9,0.4,1.7,0.7,2.5c0.3,0.7,0.7,1.5,1.1,2.1l21.5,35.1h8.7v-37.5
		c0-2.6,0.4-4.3,1.2-5.1s2.2-1.3,4.4-1.3h0.9v-5h-18V93.9z"
                            />
                        </g>
                        <path
                            d="M113.4,225.4c-61.8,0-112-50.2-112-112c0-61.8,50.2-112,112-112c61.8,0,112,50.2,112,112
	C225.4,175.1,175.1,225.4,113.4,225.4z M113.4,16.4c-53.5,0-97,43.5-97,97c0,53.5,43.5,97,97,97s97-43.5,97-97
	C210.4,59.9,166.9,16.4,113.4,16.4z"
                        />
                    </svg>
                </p>
                <h6>NSDL</h6>
            </div>
        </>
    );
};

export default NSDLIcon;
